import { IMEventBus } from "lib/mp-stjk-im-service";
// const linkImg = require('./images/link.png')
// const avartarImg = require('./images/user-avartar.png')
// const lineImg = require('./images/separator-line.png')
// const questionImg = require('./images/question.png')

Component({
  properties: {
    cardData: {
      type: Object,
      value: {}
    },
  },
  data: {},
  methods: {
    onQuestion:function() {
      let { dialog } = this.data.cardData;
      if (dialog && typeof dialog == 'string') {
        dialog = JSON.parse(dialog);
      }
      if (dialog) {
        IMEventBus.trigger("show-bind-info-remind", {
          remindData: dialog,
          isDialogOpen: true
        });
      }
    }
  },
  created: function () {},
  attached: function () {},
  ready: function () {},
  moved: function () {},
  detached: function () {},
});
